import {getFirebaseAuthHeaders} from './assetAuth'

/**
 * Delete user-uploaded assets from S3 (best-effort). Used when the editor replaces an
 * image so the superseded object doesn't linger as a quota-consuming zombie. Only the
 * caller's own keys are removed server-side; failures are swallowed because a periodic
 * server sweep is the backstop.
 */
export const deleteAssets = async (keys: string[]): Promise<void> => {
  if (keys.length === 0) return
  try {
    const headers = await getFirebaseAuthHeaders()
    await fetch('/api/assets', {
      method: 'DELETE',
      headers: {...headers, 'Content-Type': 'application/json'},
      body: JSON.stringify({keys}),
    })
  } catch {
    // Non-fatal — the server-side orphan sweep will reclaim it later.
  }
}
